import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { CMSPopupDialog } from '../model/CMSPopupDialog';

export const usePopupDialogs = () => {
    const { cmsData } = useStaticQuery(graphql`
        query {
            cmsData(name: { eq: "finddoc-popup-dialogs" }) {
                data
            }
        }
    `);

    const dialogs: CMSPopupDialog[] = JSON.parse(cmsData.data)
        .map(x => new CMSPopupDialog(x));

    const weightSum = dialogs.reduce((x, y) => x + y.weight, 0);

    const getDisplayDialog = React.useCallback(() => {
        const randomResult = Date.now() % weightSum;
        let currentWeight = 0;
        for (const d of dialogs) {
            currentWeight += d.weight;
            if (randomResult < currentWeight) {
                return d;
            }
        }
    }, [dialogs]);

    return {
        dialogs,
        getDisplayDialog,
    };
}